module.exports = __webpack_public_path__ + "img/skin-diagnostic-icon-orange.93de049e.svg";